module.exports = __webpack_public_path__ + "img/Grupo 250.b7473bd6.png";